import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { createInstance } from '../../utils/dynamic-items-utils';
import { userNameProvider } from '../helpers/user-name-provider';

export function header(): IDynamicItem {
  const headerText = createInstance({
    id: 'header-text',
    contentTypeId: 'dynamic-elements-simple-text',
    if: [
      'EQ',
      [
        {
          provider: 'id:root',
          property: 'hasPresetSelectHeader',
        },
        false,
      ],
    ],
    styles: {
      classes: ['header-text', 'h3', 'd-block', 'text-truncate'],
      style: {
        display: 'block',
        'margin-bottom': '0',
        'text-align': 'center',
        __multiple__: {
          provider: 'id:root',
          property: 'headerStyle',
        },
      },
      variables: {
        '--text-dynamic-color': 'var(--dark-mode-gray-600, #414141)',
      },
    },
    inputs: {
      text: userNameProvider,
    },
  });

  return headerText;
}
